<template>
  <b-navbar v-if="selectedTreatment" type="dark" class="lab-sub-header">
    <back-button/>

    <div class="moving">
      <b-nav-text v-if="selectedPatient">
        <i class="fa fa-circle" :style="`color: ${selectedPatient.color}`"/>
      </b-nav-text>

      <b-nav-text v-if="selectedSlide">
        <slide-treatment-id :slide="activeSlide"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <age-info v-if="selectedPatient" :treatment="selectedTreatment"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <fertilization-time :hours="selectedTreatment.hoursSinceFertilization"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <treatment-status :status="selectedTreatment.status"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <treatment-start-date :date="selectedTreatment.startDate"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <medical-decision-summary :wells="selectedTreatment.wellsByIndex"/>
      </b-nav-text>

      <b-nav-text class="v-divider"/>

      <b-nav-text>
        <items-count
            :slides="selectedTreatment.slides"
            :wells="selectedTreatment.wellsByIndex"
        />
      </b-nav-text>


    </div>

    <!--        <b-nav-text v-if="$route.name === $paths.TREATMENTS">-->
    <!--            <compare-group />-->
    <!--        </b-nav-text>-->

    <!--        <page-actions />-->
  </b-navbar>
</template>

<script>
import {mapState} from 'vuex'
import BackButton from './partials/BackButton'
import ItemsCount from './partials/ItemsCount'
import PageActions from './partials/PageActions'
import CompareGroup from './partials/CompareGroup'
import TreatmentStatus from './partials/TreatmentStatus'
import FertilizationTime from './partials/FertilizationTime'
import TreatmentStartDate from './partials/TreatmentStartDate'
import MedicalDecisionSummary from './partials/MedicalDecisionSummary'
import SlideTreatmentId from './common/SlideTreatmentId'
import AgeInfo from './common/AgeInfo'


export default {
  name: 'LabSubHeader',
  components: {
    SlideTreatmentId,
    ItemsCount,
    TreatmentStartDate,
    FertilizationTime,
    AgeInfo,
    TreatmentStatus,
    MedicalDecisionSummary,
    BackButton
  },
  computed: {
    ...mapState({
      selectedSlide: state => state.timelapse.selectedSlide,
      selectedPatient: state => state.timelapse.selectedPatient,
      selectedTreatment: state => state.timelapse.selectedTreatment,
      selectedTenant: state => state.common.selectedTenant
    }),
    activeSlide() {
      return this.selectedSlide || this.selectedTreatment.slides[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.lab-sub-header {
  padding: 0;
  height: $sub-header-height;
  font-size: 10pt;
  white-space: nowrap;
  border-bottom: $border-narrow-dark;
  z-index: 25;

  .fa-circle {
    margin: 0 0.5rem;
  }

  .v-divider {
    border-right: solid 0.1rem $dark;
    height: 40%;

    @media screen and #{$new-break3close} {
      padding-left: 0.5rem;
      margin-right: 0.5rem;
    }
    @media screen and #{$new-break4open} {
      padding-left: 1rem;
      margin-right: 1rem;
    }
  }

  .moving {
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    margin-right: auto;

    // to fix update age dialog visibility
    &:has(.update-age-dialog, .confirm-fertilization-approval-dialog) {
      overflow: visible;
    }

    &:has(.slides-menu.show) {
      overflow: visible;
    }
  }
}
</style>

<style lang="scss">
.lab-sub-header {
  .age-info .update-age-dialog {
    left: 0;

    @media screen and #{$new-break1} {
      left: -5rem;
    }

    @media screen and #{$new-break2} {
      right: calc(50% - 10rem);
    }
  }

  .slides-menu .slide-treatment-id {
    left: 0;

    @media screen and #{$new-break2close} {
      left: calc(50% - 10rem);
    }
  }
}
</style>
